import { Home, PieChart } from "react-feather";
export const ADMIN_MENUITEMS = [
  {
    Items: [
      {
        title: "training_path_manage_paths",
        icon: Home,
        type: "sub",
        badge: "badge badge-success",
        active: false,
        children: [
          {
            path: `/training-paths`,
            title: "training_path_list",
            type: "link",
          },
          {
            path: `/training-paths/archive`,
            title: "archived_training_path_list",
            type: "link",
          },
        ],
      },
      {
        title: "statistics",
        icon: PieChart,
        type: "link",
        path: `/training-paths/statistics`,
        badge: "badge badge-success",
      },
    ],
  },
];

export const USER_MENUITEMS = [
  {
    menutitle: "training_path_section_name",
    menucontent: "training_path_subsection_name",
    Items: [
      {
        title: "training_path_list",
        icon: Home,
        badge: "badge badge-success",
        active: true,
        path: `/training-paths`,
        type: "link",
      },
    ],
  },
];
